import React from 'react'
import { registerSlide } from './registry'
import { QualEditorialSlide } from './QualEditorialSlide'
import { hasRetiredQualLayout } from './slide-retirement'
import type { EditableSlideProps } from './contracts'
import type { QualAnalysisSlideData } from './renderer-internal-types'

function QualAnalysisSlideComponent(props: QualAnalysisSlideData & EditableSlideProps) {
  // Deck preparation removes this page; direct component callers render nothing.
  if (hasRetiredQualLayout(props)) return null

  return <QualEditorialSlide
    {...props}
    themes={Array.isArray(props.themes) ? props.themes : []}
    insightBlocks={Array.isArray(props.insightBlocks) ? props.insightBlocks : []}
  />
}

export const QualAnalysisSlide = registerSlide('qual-analysis', QualAnalysisSlideComponent)
